import { mapGetters, mapActions } from 'vuex';
import store from './store';
import typeMapping from './typeMapping';

const getterList = typeMapping.map(type => `areaList${type.value}`);
const actionsList = typeMapping.map(type => `fetchAreaList${type.value}`);

export default {
  props: {
    accessType: {
      type: Number,
      default: 1, // 0 全部 1 权限
    },
  },
  created() {
    store.install(this.$store);
  },
  mounted() {
    if (
      this[`areaList${this.accessType}`] &&
      !this[`areaList${this.accessType}`].length
    ) {
      this[`fetchAreaList${this.accessType}`]();
    }
    // if (!this.areaList.length) {
    //   this.fetchAreaList();
    // }
  },
  computed: {
    ...mapGetters('area', getterList),
    areaList() {
      return this[`areaList${this.accessType}`];
    },
  },
  methods: {
    ...mapActions('area', actionsList),
    getAreaName(id) {
      let item = this[`areaList${this.accessType}`].find(
        area => area.id === id
      );
      if (item) {
        return item.areaName;
      } else {
        return '';
      }
    },
    getAreaOperatorInfo(id) {
      let item = this[`areaList${this.accessType}`].find(
        area => area.id === id
      );
      if (item) {
        return {
          rechargeOperateId: item.rechargeOperateId,
          rechargeOperateName: item.rechargeOperateName,
        };
      } else {
        return null;
      }
    },
  },
};
